import { useEffect, useRef, useState } from "react";

export interface RumProviderAdapter {
  disable: () => void;
  enable: () => void;
  initialize: () => boolean;
  trackUser: (userId: string) => void;
}

interface UseConsentGatedRumOptions {
  rum: RumProviderAdapter;
  performanceAllowed: boolean;
  merchantId?: string;
}

export const useConsentGatedRum = ({
  rum,
  performanceAllowed,
  merchantId,
}: UseConsentGatedRumOptions): boolean => {
  const [isEnabled, setIsEnabled] = useState(false);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!performanceAllowed) {
      rum.disable();
      setIsEnabled(false);
      hasInitialized.current = false;
      return;
    }

    if (hasInitialized.current) {
      return;
    }

    rum.enable();
    const success = rum.initialize();
    setIsEnabled(success);
    hasInitialized.current = success;
  }, [performanceAllowed, rum]);

  useEffect(() => {
    if (!isEnabled || !performanceAllowed || !merchantId) {
      return;
    }

    rum.trackUser(merchantId);
  }, [isEnabled, merchantId, performanceAllowed, rum]);

  return isEnabled;
};
